import { useEffect } from 'react';

/**
 * Custom hook to set the page title dynamically
 * @param title - The title to set (will be prefixed with environment if not production)
 */
export const usePageTitle = (title: string) => {
  useEffect(() => {
    const env = import.meta.env.VITE_ENV || 'local';
    const prefix = env !== 'production' ? `[${env.toUpperCase()}] ` : '';
    document.title = `${prefix}${title}`;

    // Cleanup: restore default title when component unmounts
    return () => {
      document.title = env !== 'production' ? `Admin - ${env.toUpperCase()}` : 'Admin';
    };
  }, [title]);
};
